var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ready)?[_vm._m(0)]:_vm._e()],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"amzn-buy-now","data-site-id":_vm.siteId,"data-widget-id":_vm.widgetId,"data-sku":_vm.sku}})
}]

export { render, staticRenderFns }